import parentTestService from '../ParentTestService';
import sessionReader from '../../store/readHelpers/SessionReader';
import remoteOralExamService from '../RemoteOralExamService';
import uiService from '../UIService';
import preCheckService from '../PreCheckService';

// Maps the component props into deduced props, that way we keep testable logic outside of the component which
// stays really pure (status-free and service-free)
const mapToProps = (ownProps) => {
    const {
        cacheStatus,
        parentTest,
        standaloneTest,
        offlineFileDeliveryStatus,
        timeHasExpired,
        navigationLock,
        pendingAssessments,
        livestream,
        idverification,
        remoteOralExam,
    } = ownProps;

    const childTests = parentTest.childTests ? Array.from(parentTest.childTests) : [];
    const allChildTestsFinished = !standaloneTest && childTests.every((childTest) => {
        return parentTestService.isChildTestCompleted(childTest, offlineFileDeliveryStatus);
    });
    const shouldUseCountdown = sessionReader.isParentTest();

    const showComponentsDoneBox = uiService.showComponentsDoneBox(allChildTestsFinished, timeHasExpired, remoteOralExam);
    const isRemoteExam = sessionReader.isRemoteOralExam();
    const showRemoteOral = isRemoteExam && !remoteOralExamService.isTestCompleted(remoteOralExam);
    const showStandaloneLiveSessionTest = !!standaloneTest && !isRemoteExam;
    const isReadinessCheckComplete = preCheckService.readinessCheckCompleted();
    const isReadinessCheckEnabled = sessionReader.hasReadinessCheck();
    const shouldShowPreChecks = !showComponentsDoneBox && !!(isReadinessCheckEnabled || sessionReader.isVideoAudioCheckEnabled());
    const remoteOralCandidateJoined = showRemoteOral && remoteOralExamService.isCandidateJoined(remoteOralExam);
    const remoteOralInProgress = remoteOralExamService.isInProgress(remoteOralExam.sessionInfo);
    const standaloneTestCacheStatus = (standaloneTest && cacheStatus[standaloneTest.assessmentRunId]) || {};

    let readinessCheckProps = null;
    if (isReadinessCheckEnabled) {
        const readinessCheckData = {
            contentRevisionId: sessionReader.getReadinessCheckContentRevisionId(),
            isReadinessCheck: true,
            title: sessionReader.getReadinessCheckTitle(),
            isReadinessCheckComplete,
            orderNumber: -1,
        };

        readinessCheckProps = {
            unwrapChild: true,
            cacheStatus: (cacheStatus[readinessCheckData.contentRevisionId] || {}),
            test: readinessCheckData,
            parentTest,
            isCompleted: isReadinessCheckComplete,
            offlineFileDeliveryStatus,
            navigationLock,
            pendingAssessments,
            livestream,
            idverification,
        };
    }

    return {
        allChildTestsFinished,
        childTests,
        isReadinessCheckComplete,
        readinessCheckProps,
        remoteOralCandidateJoined,
        remoteOralInProgress,
        shouldShowPreChecks,
        shouldUseCountdown,
        showComponentsDoneBox,
        showRemoteOral,
        showStandaloneLiveSessionTest,
        standaloneTestCacheStatus,
    };
};

const TestComponentsSelector = {
    mapToProps,
};

export default TestComponentsSelector;
